<template>
  <ContentDisplay data-testid="partner-card">
    <template #content-block-1>
      <ListDisplay
        align-vertical
        value-as-bold
        title="Especialista responsável"
        :value="partnerName"
      />
    </template>
  </ContentDisplay>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ContentDisplay, ListDisplay } from '@warrenbrasil/nebraska-web';

@Component({
  components: {
    ContentDisplay,
    ListDisplay
  }
})
export default class PartnerCard extends Vue {
  @Prop({ type: String, required: true })
  private partnerName!: string;
}
</script>

<style lang="less" scoped>
.content-display {
  max-width: 344px;
}
</style>
